import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import incomeItemApi from 'api/incomeItemApi'

export const thunkIncomeItem = createAsyncThunk(
  'income-item/find',
  async (param, thunkApi) => {
    try {
      const res = await incomeItemApi.findApi(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
export const thunkSaveIncomeItem = createAsyncThunk(
  'income-item/save',
  async (body, thunkApi) => {
    try {
      const res = await incomeItemApi.save(body)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
export const thunkDeleteIncomeItem = createAsyncThunk(
  'income-item/delete',
  async (param, thunkApi) => {
    try {
      const res = await incomeItemApi.delete(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
const reportSlice = createSlice({
  name: 'incomeItem',
  initialState: {
    processes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkIncomeItem.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(thunkIncomeItem.fulfilled, (state, action) => {
        state.loading = false
        state.processes = action.payload // Cập nhật state với dữ liệu trả về
      })
  },
})

const { reducer } = reportSlice
export default reducer
